"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventMissionDetailSchema = void 0;
const yup = __importStar(require("yup"));
const arct_entity_schedule_1 = require("./entities/arct-entity/arct-entity.schedule");
const transition_entity_schedule_1 = require("./entities/transition-entity/transition-entity.schedule");
exports.eventMissionDetailSchema = yup.object().shape({
    id: yup.string().notRequired(),
    callSign: yup.string().notRequired(),
    missionNumber: yup.string().notRequired(),
    departure: yup.string().notRequired(),
    arrival: yup.string().notRequired(),
    transition: yup.array().of(transition_entity_schedule_1.transitionEntitySchema).nullable().notRequired(),
    arct: yup.array().of(arct_entity_schedule_1.arctEntitySchema).nullable().notRequired(),
    lowLevelInfo: yup.string().notRequired(),
    moaInfo: yup.string().notRequired(),
    route: yup.string().notRequired(),
    tankerDetail: yup
        .string()
        .matches(/^\d{1,5}$/, 'Tanker DetailMust be only digits')
        .notRequired(),
    receiverDetail: yup.string().notRequired(),
    arctInfo: yup
        .string()
        .matches(/^\d{1,5}$/, 'ARCT Info Must be only digits')
        .notRequired(),
    eventMissionId: yup.string().notRequired(),
    missionSymbol: yup.string().notRequired(),
});
